import { ApiError } from '../client';
import { getExtendCustodyMockError, markDeliveryCustodyExtendedInMock } from './deliveryDetail';

// Mock of the extend-custody WRITE: simulate latency, then either reject with an injected backend
// error code (dev/test hook, so the per-code banners are exercisable) or apply the chosen day to the
// shared detail mock, so a follow-up fetchDeliveryDetailMock returns the new expiration with the
// «extended» flag on. Idempotent, like the real endpoint is asked to be.
export async function extendCustodyMock(id: string, expirationDate: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const injected = getExtendCustodyMockError();
  if (injected !== null) {
    throw new ApiError(409, injected, { code: injected }, `extend custody failed: ${injected}`);
  }
  markDeliveryCustodyExtendedInMock(id, expirationDate);
}
